import React, { FC }               from 'react';
import { RouteComponentProps }     from 'react-router-dom';
import { EAuctionsPage }           from '@enums/auction';
import { AuctionsSortedContainer } from './AuctionsSortedContainer';
import { AuctionsSearchContainer } from './AuctionsSearchContainer';

interface IParams {
  cuid : string;
  id   : string;
  page : EAuctionsPage;
}

export const AuctionsMainContainer: FC<RouteComponentProps<IParams>> = ({
  match: {
    params: {
      page = EAuctionsPage.Search,
      cuid,
      id,
    },
  },
  history: {
    push,
  },
}) => (
  <>
    {page === EAuctionsPage.Search && (
      <AuctionsSearchContainer push={push} />
    )}

    {page === EAuctionsPage.NadaAuctions && (
      <AuctionsSortedContainer
        push      = {push}
        invoiceId = {id}
        cuid      = {cuid}
      />
    )}
  </>
);
